// extracted by mini-css-extract-plugin
export default {"UpsellSummary":"UAx1NbroPHQRivpUknf3","UpsellSummary__heading":"NwLIFRnEzcaRAWR6qdHr","UpsellSummary__heading__price":"q3DNihz5pQ43VQaGHROt"};